module.exports = __webpack_public_path__ + "static/media/Disexbg.8254a27c.jpg";